import { render, staticRenderFns } from "./documentSummary.vue?vue&type=template&id=5abf7dc8"
import script from "./documentSummary.vue?vue&type=script&lang=js"
export * from "./documentSummary.vue?vue&type=script&lang=js"
import style0 from "./documentSummary.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports